/**
 * Gestion de la modale d'aide
 * Ce module permet d'afficher et de cacher la modale d'aide
 * quand l'utilisateur clique sur le bouton d'aide.
 */

/**
 * Initialisation des gestionnaires d'événements pour la modale d'aide
 */
function initHelpModal() {
  const helpBtn = document.getElementById('help-btn');
  const helpModal = document.getElementById('help-modal');
  const closeHelpModal = document.getElementById('close-help-modal');

  if (!helpBtn || !helpModal || !closeHelpModal) {
    console.error('Éléments de la modale d\'aide non trouvés dans le DOM');
    return;
  }

  // Ouvrir la modale avec le système unifié
  helpBtn.addEventListener('click', () => {
    helpModal.style.display = 'flex';
  });

  // Fermer avec le système global
  closeHelpModal.addEventListener('click', () => {
    closeModal('help-modal');
  });

  // Fermer en cliquant en dehors
  helpModal.addEventListener('click', (event) => {
    if (event.target === helpModal) {
      closeModal('help-modal');
    }
  });

  // Empêcher la fermeture sur le contenu
  const modalContent = helpModal.querySelector('.modal-content');
  if (modalContent) {
    modalContent.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }
}

export { initHelpModal };